import React, {useEffect} from "react"
import {withPrefix} from "gatsby"
import styled from "styled-components"
import ReactHtmlParser from "react-html-parser";

import UNIVERSAL_HEADER_DATA from "../data/header"
import HERO_BANNER_DATA from "../data/en/HeroBanner"

import Title from "@airasia/phoenix-components/components/Title"
import Image from "@airasia/phoenix-components/components/Image"
import Link from "@airasia/phoenix-components/components/Link"
import Text from "@airasia/phoenix-components/components/Text"
import Button from "@airasia/phoenix-components/components/button"
import Table from "@airasia/phoenix-components/components/Table"
import FAQ from "@airasia/phoenix-widgets/widgets/FAQ"

import Tab from"../components/EnTab"

// import RideAppDownload from "../components/RideAppDownload"
// import RideAppDownload_Data from "../data/en/RideAppDownload"


import FAQ_DATA from "../data/en/faq"
import BecomeDriverRider_data from "../data/en/BecomeDriverRider"
import Layout from "../components/layout"
import "../css/main.css"
import {fireGtmEvent, getGtmUserType} from "../utils/functions"
import { symbol } from "prop-types"


const ContentWrapper = styled.div`
    width: 80%;
    margin:5em auto;
    max-width: 1160px;
    text-align: center;

    #ctaButton{
      width:30%;
      margin:2em auto;
      text-align:center;
    }

    #button-gap {margin: 10px;}

    #faq{text-align:left;}
  

  @media only screen and (max-width: 720px) {
    max-width: 625px;
    margin:3em auto;
    width: 80%;
  
  #ctaButton{
    width:60%; 
  }
  }
`

const AlignLeft = styled.div`
  text-align:left;
  `

const CoralWrapper = styled.div`
  background-color:#ffebe6;
  padding:1rem;
  `

const GreyWrapper= styled.div`
background-color:#f8f8f8;
  `


const TitleWrapper = styled.div`

  #title {
    color: #ff0000;
    font-weight: 700;
    font-size: 2rem;
    margin-bottom:0.5em;  
  }

  @media only screen and (max-width: 720px) {
    width: 100%;

    #title {
      font-size: 1.6rem;
      line-height:30px;
    }
  }
`



/*Why become our AirAsia allstar Driver / Rider?----------*/
const MerchantWrapper = styled.div`
  width: 100%;
  margin: 1em auto 3em;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  text-align:center;

  @media only screen and (max-width: 400px) {
    width: 100%;
    gap: 10px;
  }
`

const Merchant = styled.div`
  display: block;
  width:33%;
  text-align: center;

  #merchant-image, #howtobook-image  {
    background-color: transparent;
    margin:0em auto;
  }
  
  @media only screen and (max-width: 480px) {
    width:100%;
    margin: 2em auto;

    #merchant-image, #howtobook-image  {
    width:100%;
  }

  }
`

const TitleWrapperFlex = styled.div`
    padding-left: 2em;
    padding-right: 2em;
    margin:0 auto;

  #title {
    color: #ff0000;
    font-weight: 700;
    font-size: 1.2rem;
    line-height:1.5rem;
    margin-bottom:10px;
  }

  #subtitle{line-height:1.5rem; display:contents;}

  @media only screen and (max-width: 720px) {
    width: 90%;
    padding-left: 0em;
    padding-right: 0em;

    #title {
      font-size: 1.2rem;
    }
  }
`
/*end of Why become our AirAsia allstar Driver / Rider?----------*/


/*How much will part-time drivers and full-time drivers earn? ----------*/
const TableWrapper = styled.div`
  width:90%;
  text-align:left;

  #IncomeTable th, #IncomeTable td {text-align:left;}

  @media only screen and (max-width: 720px) {
    width:100%;
  }
`


/*Appdownload Tagon----------------------------*/
const Download = styled.div`
  background-color: #ff0000;
  color: #fff;
  padding: 20px 50px;
`
const DownloadContent = styled.div`
  max-width: 850px;
  display: flex;
  margin: 0 auto;

  @media only screen and (max-width: 600px) {
    display: block;
  }
`
const AppDownload = styled.div`
  display: block;
  margin: 20px auto;
  width: 60%;

  #app-download-text {
    font-style: italic;
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 20px;
  }
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`
const DownloadAppWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`
const DownloadApp = styled.div`
  margin: 3px;

  #download-image {
    background-color: transparent;
  }
`
const SuperAppIconWrapper = styled.div`
  width: 15%;
  margin: auto;

  #superapp-image {
    background-color: transparent;
  }
  @media only screen and (max-width: 600px) {
    display: none;
  }
`
const DownloadButtonWrapper = styled.div`
  margin: auto;

  #buttonDownload {
    border-radius: 40px;
    font-style: italic;
  }
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`


const IndexPage = () => {
    const updateLocale = (obj) => {
        window.location.href = withPrefix(obj.detail)
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener("uhfLocaleChange", updateLocale)
        }
    }, [])

    return (
        <Layout canonical="https://www.airasia.com/aa/driver-rider/"
                title="Register airasia driver fulltime-partime in Malaysia | airasia ride"
                description="Becoming an airasia driver to earn more income and set you own working hours. Register today and enjoy exclusive perks and benefits which cannot find anywhere else. Register now!"
                keywords="airasia rider, airasia driver, airasia e-hailing, airasia driver register, food rider, part time driver, e hailing malaysia, rider malaysia, express rider, full time delivery, part time job, side income"
                bannerData={HERO_BANNER_DATA}
                headerData={UNIVERSAL_HEADER_DATA}
        > 
            <ContentWrapper>
              <TitleWrapper>
                    <Title
                        accessible
                        inverted={false}
                        textAlign="center"
                        type="h1"
                        marginBottom="XXSmall"
                        customProperties={{id: 'title'}}
                    >
                        Join airasia’s Super Team 
                    </Title>
                    </TitleWrapper>
                    <Text
                        accessible
                        hasToggle={false}
                        opacity={1}
                        tag="p"
                        textAlign="center"
                        theme="AIRASIA_CLASSIC"
                        translation={{}}
                        type="default"
                    >
                        Guaranteed fixed income. 90% off AirAsia flights. Phone repairs. Food allowances. And more. <br/><br/>Join the airasia delivery team as we expand our e-hailing and food delivery businesses across Southeast Asia, and be on your way to better income, quicker career advancements, incomparable perks and flexible working hours. 
                    </Text>
                    
            </ContentWrapper>

          <CoralWrapper>
            <ContentWrapper>
            <TitleWrapper>
                    <Title
                        accessible
                        inverted={false}
                        textAlign="center"
                        type="h2"
                        customProperties={{id: 'title'}}
                    >
                       What drives you?
                    </Title>
                  </TitleWrapper>
                  <br/>
                  <Tab/>
                  
            </ContentWrapper>
            </CoralWrapper>

            <ContentWrapper>
                <TitleWrapper>
                    <Title
                        accessible
                        inverted={false}
                        textAlign="center"
                        type="h2"
                        marginBottom="normal"
                        customProperties={{id: 'title'}}
                    >
                       Why you should become an AirAsia allstar Driver / Rider?
                    </Title>
                  </TitleWrapper>
                  <br/>
                  <MerchantWrapper>
                       {BecomeDriverRider_data &&
                       BecomeDriverRider_data.map(BecomeDriverRider => {
                       return (
                       <Merchant>
                      <Image
                          accessible
                          width="80%"
                          customProperties={{
                          id: "howtobook-image"
                          }}
                          src={BecomeDriverRider.imageUrl} alt={BecomeDriverRider.altText}
                       />
                       <br/>
                       <TitleWrapperFlex style={{display:"block"}}>
                       <Title
                           accessible
                           inverted={false}
                           textAlign="center"
                           type="h2"
                           customProperties={{id: 'title'}}
                      >
                      {BecomeDriverRider.title}
                      </Title>
                      <Text
                           accessible
                           inverted={false}
                           textAlign="center"
                           theme="AIRASIA_CLASSIC"
                           type="p"
                           customProperties={{id: 'subtitle'}}
                      >
                      {ReactHtmlParser(BecomeDriverRider.subTitle)}
                      </Text>
                      </TitleWrapperFlex>
                      </Merchant>
                      )
                    })
                    }
                  </MerchantWrapper>    
            </ContentWrapper>

            {/* <GreyWrapper>
              <ContentWrapper style={{margin:"0 auto", padding:"0em"}}>
                  {RideAppDownload_Data && (
                        RideAppDownload_Data.map(RideAppDownload_Data => {
                                return (
                                <RideAppDownload
                                title={RideAppDownload_Data.title}
                                description={RideAppDownload_Data.description}
                                images={RideAppDownload_Data.image}
                                appstore={RideAppDownload_Data.appstoreIMG}
                                appstoreURL={RideAppDownload_Data.appstoreURL}
                                playstore={RideAppDownload_Data.playstoreIMG}
                                playstoreURL={RideAppDownload_Data.playstoreURL}
                                /> )
                            }
                  ) )}
              </ContentWrapper>
            </GreyWrapper> */}

            <ContentWrapper>
              <TitleWrapper>
            <Title
                        accessible
                        inverted={false}
                        textAlign="left"
                        type="h2"
                        customProperties={{id: 'sub-title'}}
                    >
                        FAQs
                    </Title>
                    </TitleWrapper>
                    <br/>
                <FAQ
                    data={FAQ_DATA}
                    displayIndex={false}
                    size={{}}
                    theme="AIRASIA_CLASSIC"
                    titleAlign="left"
                    textAlign="left"
                    titleMarginBottom="normal"
                    titleType="h3"
                    customProperties={{id: 'faq'}}
                />
            </ContentWrapper>

            <ContentWrapper>
              <TitleWrapper>
                    <Title
                        accessible
                        inverted={false}
                        textAlign="left"
                        type="h2"
                        customProperties={{id: 'sub-title'}}
                    >
                        How much will part-time drivers and full-time drivers earn?
                    </Title>
                    </TitleWrapper>
                    <Text
                        accessible
                        tag="p"
                    >
                        Currently, our drivers and delivery riders in Malaysia get paid RM30 per hour and this is not including the fare amount, your commission and cost. This means that you would need to drive for 4 hours to earn RM100. 
                        <br/><br/>
                        If you drive for 8 hours a day for 30 consecutive days, you will earn between RM6,000 and RM7,000 depending on other factors. airasia takes a commission of 15% from your earnings. 

                    </Text>
                    
                    <br/><br/><br/>
                    <TableWrapper>
                    <Table
                      accessible
                      columns={[
                        {
                          columnKey: 'guestName',
                          columnName: 'Hour per day'
                        },
                        {
                          columnKey: 'cabin',
                          columnName: 'Income'
                        }
                      ]}
                      customProperties={{
                        'aria-label': 'this is an a11y custom label',
                        id: 'IncomeTable'
                      }}
                      data={[
                        {
                          guestName: '4 hours / day',
                          cabin: 'RM100'
                        },
                        {
                          guestName: '8 hours / day for 30 consecutive days',
                          cabin: 'between RM 6,000 - RM 7,000  depending on contributing factors'
                        }
                      ]}
                      ellipsisLength={null}
                      isEllipsis={true}
                      isMobile={false}
                      theme="AIRASIA_CLASSIC"
                      translation={{
                        guestName: 'Hour per day',
                        cabin: 'Income'
                      }}
                      withSubLabel={false}
                    />
                    <p><em>*15% commission payable to airasia Super App.</em></p>
                    </TableWrapper>

            </ContentWrapper>

            <ContentWrapper>
              <AlignLeft>
                  <Title
                     accessible
                     inverted={false}
                     textAlign="left"
                     type="h3"
                     >
                     Related Link
                  </Title>
                    <Button
                      accessible
                      backgroundColor="default"
                      boxShadow
                      buttonType="link"
                      cardIndex={0}
                      color="neutral"
                      defaultDisabledFeatures
                      disabled={false}
                      customProperties={{
                        id: "button-gap"
                      }}
                      fontWeight="normal"
                      hoverBackgroundColor="primary"
                      hoverColor="default"
                      href="https://www.airasia.com/aa/ride/"
                      size="normal"
                      target="tab"
                      theme="AIRASIA_CLASSIC"
                      type="normal"
                    >
                      airasia ride
                    </Button>
                    
                    {/* <Button
                      accessible
                      backgroundColor="default"
                      boxShadow
                      buttonType="link"
                      cardIndex={0}
                      color="neutral"
                      defaultDisabledFeatures
                      disabled={false}
                      customProperties={{
                        id: "button-gap"
                      }}
                      fontWeight="normal"
                      hoverBackgroundColor="primary"
                      hoverColor="default"
                      href="https://www.airasia.com/aa/ride/corporate/"
                      size="normal"
                      target="tab"
                      theme="AIRASIA_CLASSIC"
                      type="normal"
                    >
                      Corporate Program
                    </Button> */}
                    <Button
                      accessible
                      backgroundColor="default"
                      boxShadow
                      buttonType="link"
                      cardIndex={0}
                      color="neutral"
                      defaultDisabledFeatures
                      disabled={false}
                      customProperties={{
                         id: "button-gap"
                      }}
                      fontWeight="normal"
                      hoverBackgroundColor="primary"
                      hoverColor="default"
                      href="https://www.airasia.com/aa/about-us/en/gb/ride-terms-and-conditions.html"
                      size="normal"
                      target="tab"
                      theme="AIRASIA_CLASSIC"
                      type="normal"
                    >
                      Ride Terms and Conditions
                    </Button>

                    {/* <Button
                      accessible
                      backgroundColor="default"
                      boxShadow
                      buttonType="link"
                      cardIndex={0}
                      color="neutral"
                      defaultDisabledFeatures
                      disabled={false}
                      customProperties={{
                         id: "button-gap"
                      }}
                      fontWeight="normal"
                      hoverBackgroundColor="primary"
                      hoverColor="default"
                      href="https://www.airasia.com/food/my/en"
                      size="normal"
                      target="tab"
                      theme="AIRASIA_CLASSIC"
                      type="normal"
                    >
                      airasia food
                    </Button> */}

                    </AlignLeft>
           </ContentWrapper>
            
           <Download>
            <DownloadContent>
              <AppDownload>
                <Text
                  accessible
                  color="default"
                  display="inlineFlex"
                  hasToggle={false}
                  opacity={1}
                  tag="p"
                  theme="AIRASIA_CLASSIC"
                  translation={{}}
                  type="default"
                  customProperties={{
                    id: "app-download-text"
                  }}
                >
                  Join now on the airasia ride Driver App
                </Text>
                <DownloadAppWrapper>
                  <DownloadApp>
                    <Link href="https://apps.apple.com/my/app/airasia-ride-driver/id1336397298">
                      <Image
                        accessible
                        height="45px"
                        customProperties={{
                          id: "download-image"
                        }}
                        src="https://www.airasia.com/aa/images/logo/app-store-badge.png" alt="AirAsia Mobile App - IOS"
                      />
                    </Link>
                  </DownloadApp>
                  <DownloadApp>
                    <Link href="https://play.google.com/store/apps/details?id=com.dacsee&hl=en&gl=US">
                      <Image
                        accessible
                        height="45px"
                        customProperties={{
                          id: "download-image"
                        }}
                        src="https://www.airasia.com/aa/images/logo/google-play-badge.png"
                        alt="AirAsia Mobile App - Google Play"
                      />
                    </Link>
                  </DownloadApp>
                </DownloadAppWrapper>
              </AppDownload>
              <SuperAppIconWrapper>
                <Image
                  accessible
                  width="90px"
                  customProperties={{
                    id: "superapp-image"
                  }}
                  src="https://www.airasia.com/aa/ride/images/super-app.png"
                  alt="airasia, The Asean Super App" />
              </SuperAppIconWrapper>
              {/* <DownloadButtonWrapper>
                <Button
                  accessible
                  buttonType="link"
                  customProperties={{
                    id: "buttonDownload",
                    paddingBottom: "1rem",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    paddingTop: "1rem"
                  }}
                  fontWeight="normal"
                  href="https://airasia.onelink.me/F4uy/8102dac5"
                  size="normal"
                  target="tab"
                  type="normal"
                  color="default"
                  backgroundColor="#fff"
                  hoverBackgroundColor="default"
                  hoverColor="primary"
                >
                  Download Now
                </Button>
              </DownloadButtonWrapper> */}
            </DownloadContent>
          </Download>

        </Layout>
    )
}

export default IndexPage
